// $(document).ready(function(){
  
//   // $(document).on('click','.custom_try_jtpl',function(){
//   //   $('.modal.addcart_popup').css('display','block');
//   // })

  
// })

$(document).ready(function () {
  
// $("body").on("click","#search_buttons",function(e){
//   e.preventDefault(); 
//    // $("#search").trigger("keyup"); 
//    // $("#search").trigger("click"); 
//    // console.log("solve");
//   return false; 
// });
  
  setTimeout(function(){
  if($("body").hasClass("ray-ban-new-product-template")){
      var html = $(".ray-ban-product-details-description").html(); 
    var htmlArr = html.split('<br><br><a href="https://www.ray-ban.com/uk/c/store-locator" target="_blank"><img align="center" src="https://cdn.shopify.com/s/files/1/0522/1610/3083/files/ray-ban-certified-2021.jpg" alt="ray-ban certified store" style="display: block; margin-left: auto; margin-right: auto;"></a>'); 
    var html_new = '<br><a href="https://www.ray-ban.com/uk/c/store-locator" target="_blank"><img align="center" src="https://cdn.shopify.com/s/files/1/0522/1610/3083/files/ray-ban-certified-2021.jpg" alt="ray-ban certified store" style="display: block; margin-left: auto; margin-right: auto;"></a>'+htmlArr[0]+ ""+htmlArr[1];
    $(".ray-ban-product-details-description").html(html_new);

  }
},500);

  
  var lastBlockAttr = parseInt($(".Last-block-jt").attr("main-index-all"));

 //  setTimeout(function(){
 //   $('.media-360-cell-jt.jt_clk').trigger('click');
 //   $('.ifram-view').removeClass('iFrame_blur_jt');
 // },100);

  

  // $(document).on('click','.custom_try_jtpl',function(){
  //   $('.modal.addcart_popup').css('display','block');
  //   $('#vir_overlay').addClass('visible_hide_vmir');
  //   // setTimeout(function(){
  //   //   $('#bipa-submit-button').trigger('click')
  //   // },500)
  // });

  // $(document).on('click','button.needsclick',function(){
  //   var eml = $('.needsclick.go3811695165.kl-private-reset-css-Xuajs1').val();
  //   if(eml === ''){
  //   }
  //   else{
  //   $('#vir_overlay').removeClass('visible_hide_vmir');
      
  //   }
  // })

  

  // 13 December 2023 Begin.
  $(document).on("click", ".mcs-item a", function () {
    // $(this)
    //   .parents(".slick-slide")
    //   .addClass("toggle_slideWp")
    //   .siblings()
    //   .removeClass("toggle_slideWp");
    var current_media = $(this).attr("data-image");
    // $('img.lazyload-fade.ls-is-cached.lazyloaded').attr('src',current_media);

   // $(".maind-view-jtpl").hide();
    $(".MagicToolboxSlides").show();
    
    // $(".maind-view-jtpl")
    //   .find(".image-view")
    //   .html("<img src='" + current_media + "' class='images-jtpl' />");
  });

  $(document).on("click", ".media-360-cell-jt", function () {
    // $(this)
    //   .parents(".slick-slide")
    //   .addClass("toggle_slideWp")
    //   .siblings()
    //   .removeClass("toggle_slideWp");

    //$(".maind-view-jtpl").show();
   // $(".MagicToolboxSlides").hide();
    $(".maind-view-jtpl.th-3D-images").toggleClass("model-open");
    $(".MagicToolboxSlides").hide();
  });
$(document).on("click", ".maind-view-jtpl.th-3D-images .close-btn", function () {
    $(".maind-view-jtpl.th-3D-images").toggleClass("model-open");
    //$(".MagicToolboxSlides").show();
    $(".MagicToolboxSelectorsContainer.owl-carousel .js-no-transition.mz-thumb.mz-thumb-selected.active-magic-selector").trigger("click");
    $(".MagicToolboxSlides").show();
  if($('.MagicToolboxSlide[data-slide-id="spin"]').hasClass("active-magic-slide") == false){
    $(".MagicToolboxSlides .MagicToolboxSlide").addClass("active-magic-slide");
 
  }
   });
  
  // $(".new-media-inner").slick({
  //   dots: false,
  //   infinite: false,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   responsive: [
  //   {
  //     breakpoint: 1024,
  //     settings: {
  //       slidesToShow: 4,
  //       slidesToScroll: 1
  //     }
  //   },
  //   {
  //     breakpoint: 767,
  //     settings: {
  //       slidesToShow: 3,
  //       slidesToScroll: 1
  //     }
  //   }
  // ]
  // });

  $('.new-media-inner').slick({
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  responsive: [
    {
      breakpoint: 1325,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
  $(".new-media-inner .slick-slide:eq(0)").addClass("toggle_slideWp");

  // Next Previous Click Begin.

  $(document).on("click", ".prv-clk", function (e) {
    e.preventDefault();
    var P_index = $(this).parents(".quiz-content-main").attr("main-index-all");
    if (P_index > 1) {
      var NP_index =parseInt($(this).parents(".quiz-content-main").attr("main-index-all")) -1;

      $(".quiz-content-main[main-index-all=" + NP_index + "]").removeClass("jtpl_hidden");
      $(".quiz-content-main[main-index-all=" + P_index + "]").addClass("jtpl_hidden");
    }
  });

  $(document).on("click", ".nxt-clk", function (e) {
    e.preventDefault();
    var P_N_index = parseInt(
      $(this).parents(".quiz-content-main").attr("main-index-all"));
    var N_index = parseInt($(this).parents(".quiz-content-main").attr("main-index-all")) + 1;

    if (!$(this).parents(".quiz-content-main").find(".quiz-bottom-cell").hasClass("active")) {
      // alert("Please select one!");
      $(this).parents(".quiz-content-main").find(".select-once-jtpl").removeClass("jtpl_hidden");
    } else {
      if (N_index <= lastBlockAttr) {
        $(".quiz-content-main[main-index-all=" + N_index + "]").removeClass("jtpl_hidden");
        $(".quiz-content-main[main-index-all=" + P_N_index + "]").addClass("jtpl_hidden");
      } else {
        
        if($(".quiz-form-content").length > 0){
          $(".quiz-content-main[main-index-all=" + P_N_index + "]").addClass("jtpl_hidden");
          $(".quiz-form-content").removeClass("jtpl_hidden");
        }
        
      }
    }
  });

  $(document).on("click", ".form-prv-clk", function () {
    $(this).parents(".quiz-form-content").addClass("jtpl_hidden");
  //  alert('back');
    $(".Last-block-jt").removeClass("jtpl_hidden");
  });

  // Next Previous Click End.

  $(document).on("click", ".icon-check-true", function () {
    $(this).addClass("jtpl_hidden").siblings().removeClass("jtpl_hidden");
    // $('.data-submit-btn').removeClass('jtpl_hidden');
  });

  $(document).on("click", ".icon-check-false", function () {
    $(this).addClass("jtpl_hidden").siblings().removeClass("jtpl_hidden");
    // $('.data-submit-btn').addClass('jtpl_hidden');
  });

  // $(document).on('click','.quiz-bottom-cell',function(){
  //     $(this).addClass('active').siblings().removeClass('active');
  //     var get_title = $(this).find('h2').text().trim();;
  //     var get_index = $(this).parents('.quiz-content-main').attr('main-index-all');
  //   alert("title : " + get_title)
  //   alert("index : " + get_index)
  // })

  $(document).on("click", ".quiz-bottom-cell", function () {
    $(this).addClass("active").siblings().removeClass("active");

    if($(this).parents('.quiz-content-main').hasClass('current_submit_wp')){
      $(this).parents('.quiz-content-main').find('.quiz-submit-btn-jt').removeClass('Submit_trapwp');
          var crt_value22 = $(this).find("h2").text().trim();
      if(crt_value22 == "Nope, just glasses"){
        var gls = "Glasses"
        $(this).parents(".quiz-content-main").attr("data-assets", gls);
        $("input[name=sunglasses]").val(gls);
      }
      else{
        $(this).parents(".quiz-content-main").attr("data-assets","");
        $("input[name=sunglasses]").val("");
        
      }
      
      // $(this).parents('.quiz-content-main').find('.quiz-submit-btn-jt').trigger('click');
    }
    else{

    if ($(this).hasClass("active")) {
      // $(this).parents('.quiz-content-main').find('.quiz-cont-bottom').addClass('jtpl_hidden');
      $(this).parents(".quiz-content-main").find(".select-once-jtpl").addClass("jtpl_hidden");
    }
    var crt_value = $(this).find("h2").text().trim();
      console.log("previous text : " + crt_value);
      
    $(this).parents(".quiz-content-main").attr("data-assets", crt_value);
    var crt_main_value = $(this).parents(".quiz-content-main").attr("data-assets");
    var crt_index = parseInt($(this).parents(".quiz-content-main").attr("main-index-all"));
    var nxt_index = crt_index + 1;

    if ($(this).parents(".quiz-content-main").hasClass("shape")) {
      $("input[name=shape]").val(crt_main_value);
    }
    if ($(this).parents(".quiz-content-main").hasClass("color")) {
      $("input[name=color]").val(crt_main_value);
    }
    if ($(this).parents(".quiz-content-main").hasClass("material")) {
      $("input[name=material]").val(crt_main_value);
    }
    if ($(this).parents(".quiz-content-main").hasClass("sunglass")) {
      $("input[name=sunglasses]").val(crt_main_value);
    }
    if ($(this).parents(".quiz-content-main").hasClass("size")) {
      $("input[name=size]").val(crt_main_value);
    }
    if ($(this).parents(".quiz-content-main").hasClass("budget")) {
      $("input[name=budget]").val(crt_main_value);
    }
    if ($(this).parents(".quiz-content-main").hasClass("search")) {
      $("input[name=search]").val(crt_main_value);
    }

    if (nxt_index <= 6) {
   //   alert('6');
      $(".quiz-content-main[main-index-all=" + nxt_index + "]").removeClass("jtpl_hidden");
      $(".quiz-content-main[main-index-all=" + crt_index + "]").addClass("jtpl_hidden");
      //alert('6');
    }

    if (crt_index == 6) {
      $(this).parents(".quiz-content-main").find(".nxt-clk").trigger("click");
     // alert('next');
    }
  }
  });

  $(document).on("click", ".no-preferance-btn", function (e) {
    e.preventDefault();
    $(this).parents(".quiz-content-main").find(".select-once-jtpl").addClass("jtpl_hidden");
    var current_preference_index = parseInt($(this).parents(".quiz-content-main").attr("main-index-all"));
    var preference_index =parseInt($(this).parents(".quiz-content-main").attr("main-index-all")) +1;
    // alert("index : " + preference_index)
    if (preference_index <= 6) {
      $(".quiz-content-main[main-index-all=" + preference_index + "]").removeClass("jtpl_hidden");
      $(".quiz-content-main[main-index-all=" + current_preference_index + "]").addClass("jtpl_hidden");
    }
  });

  var klv_data = [];

  var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  function isValidEmail(data_em) {
    return emailPattern.test(data_em);
  }

  var data_top = "";
 $(document).on("click", ".quiz-submit-btn-jt", function (e) {
     e.preventDefault();
   if($(this).hasClass('Submit_trapwp')){
     $(this).parents('.quiz-content-main').find('.select-once-jtpl').removeClass('jtpl_hidden')
   }
   else{
     
    var collection_url = $(".quiz-qt-inner").attr("data-collection");

    var shape2 = $("input[name=shape]").val();
    var color2 = $("input[name=color]").val();
    var material2 = $("input[name=material]").val();
    var sunglasses2 = $("input[name=sunglasses]").val();
     
   // sunglasses2 = sunglasses2.toLowerCase();
   
   // if(sunglasses2.indexOf("nope") > -1){
   //   sunglass_filter = "Glasses";
   // }else{
   //   sunglass_filter="" ;
   // }

     var sunglass_filter = sunglasses2;
     console.log("sunglass_filter : " + sunglass_filter)
   
    // var wearing2 = $("input[name=wearing]").val();
    var budget2 = $("input[name=budget]").val();
    var price2 = $("input[name=price]").val();
    var size2 = $("input[name=size]").val();
    if (size2 == "Small") {
       var sizeVal ="Small%20(upto%2048mm)";
   //   var sizeVal ="20mm%7C25mm%7C28mm%7C31mm%7C32mm%7C33mm%7C34mm%7C35mm%7C36mm%7C37mm%7C38mm%7C39mm%7C40mm%7C41mm%7C42mm%7C43mm%7C44mm%7C45mm%7C46mm%7C47mm%7C48mm%7C49mm%7C50mm%7C51mm%7C52mm%7C53mm";
    } else if (size2 == "Medium") {
      var sizeVal = "Medium%20(49mm%20-%2055mm)";
    //  var sizeVal = "53mm%7C54mm%7C55mm%7C56mm";
    } else if (size2 == "Large") {
      var sizeVal = "Large%20(56mm%2B)";
    //  var sizeVal ="57mm%7C58mm%7C59mm%7C60mm%7C61mm%7C62mm%7C63mm%7C64mm%7C65mm%7C66mm%7C67mm%7C68mm%7C69mm%7C70mm%7C72mm%7C76mm%7C80mm%7C99mm%7C125mm%7C127mm%7C128mm%7C130mm%7C131mm%7C132mm%7C133mm%7C134mm%7C135mm%7C136mm%7C137mm%7C138mm%7C139mm%7C140mm%7C141mm%7C142mm%7C143mm%7C144mm%7C145mm%7C146mm%7C147mm%7C148mm%7C150mm";
    }
     

    window.location.href ="https://pretavoir.co.uk" +collection_url +"?page=1&rb_snize_facet15=" + sizeVal +"&rb_snize_facet2=" +shape2 + "&rb_snize_facet16=Colour%20-%20" +color2 +"&rb_filter_metafield_ff24ea4b9c38b859c7fef9d89b807549=" +material2 +"&rb_product_type="+sunglass_filter+"";
    }
 });
  
  $(document).on("click", ".klv-btn-jt", function (e) {
    // e.preventDefault();

    $(".quiz-content-main").each(function () {
      var new_dataAll = $(this).find(".quiz-bottom-cell.active h2").text();
      console.log("new data all : " + new_dataAll);
      klv_data.push(new_dataAll);
    });

    var data_em = $(".quiz-form-content .emailContentCell").val();
    klv_data.push(data_em);
  

    var collection_url = $(".quiz-qt-inner").attr("data-collection");

    var shape2 = $("input[name=shape]").val();
    var color2 = $("input[name=color]").val();
    var material2 = $("input[name=material]").val();
    var sunglasses2 = $("input[name=sunglasses]").val();
    // var wearing2 = $("input[name=wearing]").val();
    var budget2 = $("input[name=budget]").val();
    var price2 = $("input[name=price]").val();
    var size2 = $("input[name=size]").val();
    if (size2 == "Small") {
       var sizeVal ="Small%20(upto%2048mm)";
   //   var sizeVal ="20mm%7C25mm%7C28mm%7C31mm%7C32mm%7C33mm%7C34mm%7C35mm%7C36mm%7C37mm%7C38mm%7C39mm%7C40mm%7C41mm%7C42mm%7C43mm%7C44mm%7C45mm%7C46mm%7C47mm%7C48mm%7C49mm%7C50mm%7C51mm%7C52mm%7C53mm";
    } else if (size2 == "Medium") {
      var sizeVal = "Medium%20(49mm%20-%2055mm)";
    //  var sizeVal = "53mm%7C54mm%7C55mm%7C56mm";
    } else if (size2 == "Large") {
      var sizeVal = "Large%20(56mm%2B)";
    //  var sizeVal ="57mm%7C58mm%7C59mm%7C60mm%7C61mm%7C62mm%7C63mm%7C64mm%7C65mm%7C66mm%7C67mm%7C68mm%7C69mm%7C70mm%7C72mm%7C76mm%7C80mm%7C99mm%7C125mm%7C127mm%7C128mm%7C130mm%7C131mm%7C132mm%7C133mm%7C134mm%7C135mm%7C136mm%7C137mm%7C138mm%7C139mm%7C140mm%7C141mm%7C142mm%7C143mm%7C144mm%7C145mm%7C146mm%7C147mm%7C148mm%7C150mm";
    }

    if (isValidEmail(data_em)) {
      setTimeout(function () {
        $(".klavio-hide-data").val(klv_data);
      }, 200);
      //rb_snize_facet7=20mm%7C25mm%7C28mm%7C31mm%7C32mm%7C33mm%7C34mm%7C35mm%7C36mm%7C37mm%7C38mm%7C39mm%7C40mm%7C41mm%7C42mm%7C43mm%7C44mm%7C45mm%7C46mm%7C47mm%7C48mm%7C49mm%7C50mm%7C51mm%7C52mm%7C53mm
      window.location.href ="https://pretavoir.co.uk" +collection_url +"?page=1&rb_snize_facet15=" + sizeVal +"&rb_snize_facet2=" +shape2 + "&rb_snize_facet16=Colour%20-%20" +color2 +"&rb_filter_metafield_ff24ea4b9c38b859c7fef9d89b807549=" +material2 +"";
    } else {
      // alert('Please enter a valid email address.');
    }
  });


   });